import React, { useState, useEffect } from 'react'; // useState/useEffect não serão usados diretamente no Register mas podem ser por outras imports
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { postResetPassword, postAuth, JWT_Decode } from '../../providers/api';
import { setDialog as authDialog, setAuth } from '../../actions/authAction';
import { setLoading, setProfileDialog } from '../../actions/appActions';

// Importações do Material-UI
import { withStyles } from '@material-ui/core/styles'; // Para aplicar estilos em componentes de classe
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Slide from '@material-ui/core/Slide';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import MuiSelect from '@material-ui/core/Select'; // Renomeado para evitar conflito com 'Select' de componentes locais
import Grid from '@material-ui/core/Grid'; // Para layout responsivo

// Importações de bibliotecas externas
import { withRouter } from 'react-router-dom';
import InputMask from 'react-input-mask';
import moment from 'moment';
import ReCAPTCHA from 'react-google-recaptcha';
import Autocomplete from '@material-ui/lab/Autocomplete'; // Autocomplete do Material-UI Lab

// Ícones
import { Add, CheckCircleOutlineRounded, DeleteForever } from '@material-ui/icons';
import { BRANDING } from '../../../branding';
import { GetHandler, PostHandler } from '../../handlers';
import { CardHeader } from '@material-ui/core';

// Funções de máscara (adaptadas para uso direto no navegador, se necessário)
const toCPF = (value) => {
    if (!value) return '';
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return value;
};

const toCNPJ = (value) => {
    if (!value) return '';
    value = value.replace(/\D/g, '');
    value = value.replace(/^(\d{2})(\d)/, '$1.$2');
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
    value = value.replace(/(\d{4})(\d)/, '$1-$2');
    return value;
};

const toCep = (value) => {
    if (!value) return '';
    value = value.replace(/\D/g, '');
    value = value.replace(/^(\d{5})(\d)/, '$1-$2');
    return value;
};

const toPhone = (value) => {
    if (!value) return '';
    value = value.replace(/\D/g, '');
    value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
    value = value.replace(/(\d)(\d{4})$/, '$1-$2');
    return value;
};

// ESTILOS (usando withStyles para componente de classe)
const styles = theme => ({
    root: {
        maxWidth: 900,
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
    },
    stepHeader: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
    },
    stepFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: theme.spacing(2),
    },
    errorText: {
        color: 'red',
        fontSize: '0.8em',
        marginTop: '5px',
    },
});

// Lista de anos para Autocomplete
const yearList = [];
for (let i = 1980; i <= moment().year(); i++) {
    yearList.push({
        label: String(i),
        value: String(i),
    });
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// COMPONENTE PRINCIPAL (agora uma classe)
class Register extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            errors: {}, // Objeto para erros específicos do campo
            captcha: null,
            especialidades: [],
            conselhos: [
                { nome: "CRAS - Conselho Regional de Assistência Social", valor: "1" },
                { nome: "COREN - Conselho Regional de Enfermagem", valor: "2" },
                { nome: "CRF - Conselho Regional de Farmácia", valor: "3" },
                { nome: "CRFA - Conselho Regional de Fonoaudiologia", valor: "4" },
                { nome: "CREFITO - Conselho Regional de Fisioterapia e Terapia Ocupacional", valor: "5" },
                { nome: "CRM - Conselho regional de medicina", valor: "6" },
                { nome: "CRN - Conselho Regional de Nutrição", valor: "7" },
                { nome: "CRO - Conselho Regional de Odontologia", valor: "8" },
                { nome: "CRP - Conselho Regional de Psicologia", valor: "9" },
                { nome: "OUTROS - Outros Conselhos", valor: "10" }
            ],
            idiomas: [],
            gruposAtendimento: [],
            activeStep: 0, // Inicia na primeira etapa
            dados: {
                nome: '',
                email: '',
                sexo: '',
                tipoContrato: '', // 1: PJ, 2: Autônomo
                documentoNumero: '', // Armazena apenas números
                telefone: '', // Armazena apenas números

                endereco: {
                    cep: '', // Armazena apenas números
                    logradouro: '',
                    numero: '',
                    complemento: '',
                    bairro: '',
                    cidade: '',
                    uf: '',
                },

                dataIniProf: undefined,
                sobre: '',
                especialidadeId: '',
                especialidadeNome: '',
                conselhoProfissionalId: '',
                conselhoProfissionalUf: '',
                conselhoProfissionalNumero: '',
                grupoAtendimentoId: [],
                idiomasId: [],
                tagsTratamento: [],

                formacaoAcademica: [
                    {
                        tipo: '',
                        instituicao: '',
                        formacao: '',
                        dataDe: '',
                        dataAte: '',
                    },
                ],
                termos: false,
            },
            cadastrado: false,
            enviaDepCodConfirmacao: true,
            codigoConfirmacao: null,
        };

        this.steps = [
            'Dados Pessoais',
            'Endereço',
            'Dados Profissionais',
            'Formação Acadêmica',
            'Finalizar'
        ];
    }

    // Método de ciclo de vida equivalente ao useEffect para componentDidMount
    componentDidMount() {
        this.fetchDropdownData();
        // Inicialização de formacaoAcademica se estiver vazia
        if (this.state.dados.formacaoAcademica.length === 0) {
            this.setState(prevState => ({
                dados: {
                    ...prevState.dados,
                    formacaoAcademica: [{ tipo: '', instituicao: '', formacao: '', dataDe: '', dataAte: '' }]
                }
            }));
        }
    }

    // Método para carregar dados de dropdowns
    fetchDropdownData = async () => {
        try {
            const especialidadesRes = await GetHandler(`especialidades`, { perfilId: BRANDING?.perfilId }); // Usando props.api
            const gruposRes = await GetHandler(`gruposAtendimento`, { perfilId: BRANDING?.perfilId }); // Usando props.api
            // const [idiomasRes, gruposRes] = await Promise.all([
            //     this.props.api.get('/conselho-profissional'),
            //     this.props.api.get('/idioma'),
            //     this.props.api.get(`gruposAtendimento?perfilId=${BRANDING?.perfilId}`),
            // ]);

            console.log('especialidades::::', especialidadesRes);

            this.setState({
                especialidades: especialidadesRes?.data?.data ?? especialidadesRes?.data ?? [],
                idiomas: [
                    {
                        id: 1,
                        label: 'Português'
                    }, {
                        id: 4,
                        label: 'Alemão'
                    }, {
                        id: 3,
                        label: 'Espanhol'
                    }, {
                        id: 2,
                        label: 'Inglês'
                    }],
                gruposAtendimento: gruposRes?.data ?? [],
            });
        } catch (error) {
            // this.props.toast.error('Erro ao carregar dados de listas.');
            console.error('Erro ao carregar dados de listas:', error);
        }
    };

    // Função genérica para lidar com a mudança de campos
    handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            this.setState(prevState => ({
                dados: {
                    ...prevState.dados,
                    [name]: checked
                }
            }));
            return;
        }

        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            this.setState(prevState => ({
                dados: {
                    ...prevState.dados,
                    [parent]: {
                        ...prevState.dados[parent],
                        [child]: value
                    }
                }
            }));
        } else {
            this.setState(prevState => ({
                dados: {
                    ...prevState.dados,
                    [name]: value
                }
            }));
        }
    };

    // Função para lidar com mudanças em campos de array (ex: formacaoAcademica)
    handleArrayChange = (index, field, value, arrayName) => {
        this.setState(prevState => {
            const newArray = [...prevState.dados[arrayName]];
            newArray[index] = { ...newArray[index], [field]: value };
            return {
                dados: {
                    ...prevState.dados,
                    [arrayName]: newArray
                }
            };
        });
    };

    // Função para adicionar um novo item em um array (ex: nova formação)
    addArrayItem = (arrayName, newItem) => {
        this.setState(prevState => ({
            dados: {
                ...prevState.dados,
                [arrayName]: [...prevState.dados[arrayName], newItem]
            }
        }));
    };

    // Função para remover um item de um array (ex: remover formação)
    removeArrayItem = (index, arrayName) => {
        this.setState(prevState => {
            const newArray = prevState.dados[arrayName].filter((_, i) => i !== index);
            return {
                dados: {
                    ...prevState.dados,
                    [arrayName]: newArray
                }
            };
        });
    };

    // Define a validação para cada etapa
    validateStep = (currentStep) => {
        let newErrors = {};
        let isValid = true;
        const { dados } = this.state;

        const addError = (field, message) => {
            newErrors[field] = message;
            isValid = false;
        };

        if (currentStep === 0) { // Dados Pessoais
            if (!dados.nome) addError('nome', 'Nome é obrigatório');
            if (!dados.email) addError('email', 'E-mail é obrigatório');
            if (!dados.sexo) addError('sexo', 'Sexo é obrigatório');
            if (!dados.tipoContrato) addError('tipoContrato', 'Tipo de Contrato é obrigatório');

            // Validação condicional de CPF/CNPJ baseada em tipoContrato
            if (dados.tipoContrato === 2 && (!dados.documentoNumero || dados.documentoNumero.length !== 11)) { // Autônomo (CPF)
                addError('documentoNumero', 'CPF inválido ou obrigatório (11 dígitos)');
            } else if (dados.tipoContrato === 1 && (!dados.documentoNumero || dados.documentoNumero.length !== 14)) { // Pessoa Jurídica (CNPJ)
                addError('documentoNumero', 'CNPJ inválido ou obrigatório (14 dígitos)');
            } else if (!dados.tipoContrato) { // Se tipoContrato não selecionado ainda
                addError('documentoNumero', 'Selecione o Tipo de Contrato primeiro');
            }


            if (!dados.dataIniProf) addError('dataIniProf', 'Data de início profissional é obrigatória');
            if (!dados.telefone || dados.telefone.length < 10) addError('telefone', 'Telefone é obrigatório (mín. 10 dígitos)');

        } else if (currentStep === 1) { // Endereço
            if (!dados.endereco.cep || dados.endereco.cep.length !== 8) addError('endereco.cep', 'CEP inválido ou obrigatório');
            if (!dados.endereco.logradouro) addError('endereco.logradouro', 'Logradouro é obrigatório');
            if (!dados.endereco.numero) addError('endereco.numero', 'Número é obrigatório');
            if (!dados.endereco.bairro) addError('endereco.bairro', 'Bairro é obrigatório');
            if (!dados.endereco.cidade) addError('endereco.cidade', 'Cidade é obrigatória');
            if (!dados.endereco.uf) addError('endereco.uf', 'Estado é obrigatório');

        } else if (currentStep === 2) { // Dados Profissionais
            if (!dados.sobre) addError('sobre', 'Currículo é obrigatório');
            if (!dados.especialidadeNome) addError('especialidadeNome', 'Especialidade é obrigatória');
            if (!dados.conselhoProfissionalId) addError('conselhoProfissionalId', 'Conselho é obrigatório');
            if (!dados.conselhoProfissionalUf) addError('conselhoProfissionalUf', 'UF do conselho é obrigatória');
            if (!dados.conselhoProfissionalNumero) addError('conselhoProfissionalNumero', 'Número do conselho é obrigatório');
            if (dados.idiomasId.length === 0) addError('idiomasId', 'Selecione pelo menos um idioma');
            if (dados.grupoAtendimentoId.length === 0) addError('grupoAtendimentoId', 'Selecione pelo menos um grupo de atendimento');
            //if (dados.grupoAtendimentoId.length === 0) addError('grupoAtendimentoId', 'Selecione pelo menos um grupo de atendimento');

        } else if (currentStep === 3) { // Formação Acadêmica
            if (dados.formacaoAcademica.length === 0) {
                addError('formacaoAcademica', 'Adicione pelo menos uma formação acadêmica');
            } else {
                dados.formacaoAcademica.forEach((formacao, index) => {
                    if (!formacao.tipo) addError(`formacaoAcademica.${index}.tipo`, 'Tipo é obrigatório');
                    if (!formacao.instituicao) addError(`formacaoAcademica.${index}.instituicao`, 'Instituição é obrigatória');
                    if (!formacao.formacao) addError(`formacaoAcademica.${index}.formacao`, 'Formação é obrigatória');
                    if (!formacao.dataDe) addError(`formacaoAcademica.${index}.dataDe`, 'Data de início é obrigatória');
                });
            }
        } else if (currentStep === 4) { // Finalizar
            if (!this.state.captcha) addError('captcha', 'Por favor, complete o reCAPTCHA');
            if (!dados.termos) addError('termos', 'Você deve aceitar os termos de serviço');
        }

        this.setState({ errors: newErrors });
        return isValid;
    };

    // HANDLERS DE NAVEGAÇÃO
    handleNext = () => {
        const { activeStep } = this.state;
        const ok = this.validateStep(activeStep);
        if (!ok) return;

        if (activeStep === this.steps.length - 1) {
            if (!this.state.captcha) {
                alert('Por favor, complete o reCAPTCHA para finalizar.');
                return;
            }
            if (!this.state.dados.termos) {
                alert('Você deve aceitar os termos de serviço para finalizar.');
                return;
            }
        }

        this.setState(prevState => ({
            activeStep: Math.min(prevState.activeStep + 1, this.steps.length - 1),
            errors: {}, // Limpa erros ao avançar
        }));
    };

    handleBack = () => {
        this.setState(prevState => ({
            activeStep: Math.max(prevState.activeStep - 1, 0),
            errors: {}, // Limpa erros ao voltar
        }));
    };

    // FUNÇÃO DE ENVIO FINAL DO FORMULÁRIO
    registerHandler = async (e) => {
        if (e && e.preventDefault) e.preventDefault();

        let allStepsValid = true;
        // for (let i = 0; i < this.steps.length; i++) {
        //     if (!this.validateStep(i)) {
        //         allStepsValid = false;
        //         this.setState({ activeStep: i }); // Volta para a primeira etapa com erro
        //         this.props.toast.error('Por favor, preencha todos os campos obrigatórios em todas as etapas.');
        //         return;
        //     }
        // }

        this.setState({ loading: true });

        try {
            const { dados, captcha } = this.state;
            if(dados.tipoContrato == 1) {
                dados.cnpj = dados.documentoNumero;
            }else{
                dados.cpf = dados.documentoNumero;

            }

            let dadosl = {
                nome: "Ephyllus Oliveira",
                email: "ephyllus2@teste.com",
                sexo: "M",
                tipoContrato: 1,
                documentoNumero: "12312321321321",
                telefone: "88888888888",
                endereco: {
                    cep: "04949140",
                    logradouro: "Rua Agostinho Ferreira Escudeiro",
                    numero: "77",
                    complemento: "",
                    bairro: "Jardim Aracati",
                    cidade: "São Paulo",
                    uf: "SP"
                },
                dataIniProf: "2025-08-01",
                sobre: "TESTE de curriculo profissional escrito com várias palavras para avaliar a quebração de linhas",
                especialidadeId: "",
                especialidadeNome: "Angiologia",
                conselhoProfissionalId: "4",
                conselhoProfissionalUf: "SP",
                conselhoProfissionalNumero: "887732",
                grupoAtendimentoId: [],
                idiomasId: "4,3",
                tagsTratamento: ",2,3,5",
                formacaoAcademica: [
                    {
                        tipo: "Graduação",
                        instituicao: "FMU",
                        formacao: "Tecnologia",
                        dataDe: "1998-01-01",
                        dataAte: "2000-01-01"
                    }
                ],
                termos: true,
                perfilId: 3580,
                aprovacao: true,
                captcha: null
            }
            const dataToSend = {
                ...dados,
                perfilId: BRANDING?.perfilId,
                aprovacao: true,
                idiomasId: dados.idiomasId.length > 0 ? dados.idiomasId : undefined,
                tagsTratamento: dados.tagsTratamento.length > 0 ? dados.tagsTratamento.join(',') : '',
                grupoAtendimentoId: dados.grupoAtendimentoId.length > 0 ? dados.grupoAtendimentoId : undefined,
                captcha: captcha // Inclui o captcha no payload
            };

            const registerResponse = await PostHandler("doutores", dataToSend, this.props.navigation);
            console.log('ENVIO ',registerResponse,  dataToSend);

            if (registerResponse?.data?.success == true) {
                let message = registerResponse?.data?.message || 'Enviado com Sucesso!';
                alert(message);
                this.setState({ cadastrado: true }); // Se necessário uma tela de sucesso
                setTimeout(() => {
                    window.open('https://ibac.com.br/cadastro-realizado/', '_blank');
                }, 5000);
            } else {
                let errorMessage = registerResponse?.data?.message || registerResponse?.message || 'Problema ao cadastrar!!.';
                alert(errorMessage);
                this.setState({ errors: registerResponse?.data?.errors || {} });
            }
        } catch (error) {
            alert('Erro de rede ou servidor ao cadastrar.');
            console.log('Erro no registro:', error);
            if (error.response && error.response.data && error.response.data.errors) {
                this.setState({ errors: error.response.data.errors });
            }
        } finally {
            this.setState({ loading: false });
        }
    };

    // Componente para renderizar o conteúdo da etapa atual
    StepContent = ({ stepIndex }) => {
        const { dados, errors, especialidades, conselhos, idiomas, gruposAtendimento, loading } = this.state;
        const { classes } = this.props;

        switch (stepIndex) {
            case 0:
                return (
                    <>
                        {/* Etapa 1: Dados Pessoais e Contato */}
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    error={!!errors.nome}
                                    helperText={errors.nome}
                                    type="text"
                                    fullWidth
                                    id="nome"
                                    name="nome"
                                    label="Nome Completo"
                                    variant="outlined"
                                    value={dados.nome}
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    type="email"
                                    fullWidth
                                    id="email"
                                    name="email"
                                    label="E-mail"
                                    variant="outlined"
                                    value={dados.email}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" error={!!errors.sexo}>
                                    <InputLabel id="sexo-select-label" style={{ fontWeight: 'bold' }}>Sexo</InputLabel>
                                    <MuiSelect
                                        labelId="sexo-select-label"
                                        id="sexo"
                                        name="sexo"
                                        value={dados.sexo}
                                        onChange={this.handleChange}
                                        label="Sexo"
                                    >
                                        <MenuItem value=""><em>Selecione</em></MenuItem>
                                        <MenuItem value={"M"}>Masculino</MenuItem>
                                        <MenuItem value={"F"}>Feminino</MenuItem>
                                        <MenuItem value={"O"}>Outro</MenuItem>
                                    </MuiSelect>
                                    {errors.sexo && <Typography className={classes.errorText}>{errors.sexo}</Typography>}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" error={!!errors.tipoContrato}>
                                    <InputLabel id="tipoContrato-select-label" style={{ fontWeight: 'bold' }}>Tipo de Contrato</InputLabel>
                                    <MuiSelect
                                        labelId="tipoContrato-select-label"
                                        id="tipoContrato"
                                        name="tipoContrato"
                                        value={dados.tipoContrato}
                                        onChange={this.handleChange}
                                        label="Tipo de Contrato"
                                    >
                                        <MenuItem value=""><em>Selecione</em></MenuItem>
                                        <MenuItem value={1}>Pessoa Jurídica</MenuItem>
                                        <MenuItem value={2}>Autônomo</MenuItem>
                                    </MuiSelect>
                                    {errors.tipoContrato && <Typography className={classes.errorText}>{errors.tipoContrato}</Typography>}
                                </FormControl>
                            </Grid>

                            {/* REMOVIDO: Campo de seleção de Tipo de Documento */}
                            {/* O tipo de documento (CPF/CNPJ) será inferido do Tipo de Contrato */}

                            <Grid item xs={12} sm={6}>
                                <InputMask
                                    // Máscara condicional baseada no tipoContrato
                                    mask={dados.tipoContrato === 2 ? '999.999.999-99' : (dados.tipoContrato === 1 ? '99.999.999/9999-99' : '')}
                                    // Valor exibido formatado, mas o estado armazena o rawValue
                                    value={dados.tipoContrato === 2 ? toCPF(dados.documentoNumero) : (dados.tipoContrato === 1 ? toCNPJ(dados.documentoNumero) : dados.documentoNumero)}
                                    onChange={(e) => {
                                        const rawValue = e.target.value.replace(/\D/g, '');
                                        this.handleChange({ target: { name: 'documentoNumero', value: rawValue } });
                                    }}
                                    disabled={!dados.tipoContrato} // Desabilita se tipoContrato não selecionado
                                >
                                    {(inputProps) => (
                                        <TextField
                                            {...inputProps}
                                            InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                            error={!!errors.documentoNumero}
                                            helperText={errors.documentoNumero}
                                            fullWidth
                                            id="documentoNumero"
                                            // Label condicional
                                            label={dados.tipoContrato === 2 ? 'CPF' : (dados.tipoContrato === 1 ? 'CNPJ' : 'Documento')}
                                            variant="outlined"
                                        />
                                    )}
                                </InputMask>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' }, shrink: true }}
                                    error={!!errors.dataIniProf}
                                    helperText={errors.dataIniProf}
                                    id="dataIniProf"
                                    name="dataIniProf"
                                    label="Data de início da atividade profissional"
                                    type="date"
                                    fullWidth
                                    variant="outlined"
                                    value={dados.dataIniProf}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputMask
                                    mask="(99) 99999-9999"
                                    value={toPhone(dados.telefone)} // Passa o valor formatado para a máscara
                                    onChange={(e) => {
                                        const rawValue = e.target.value.replace(/\D/g, '');
                                        this.handleChange({ target: { name: 'telefone', value: rawValue } });
                                    }}
                                >
                                    {(inputProps) => (
                                        <TextField
                                            {...inputProps}
                                            InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                            error={!!errors.telefone}
                                            helperText={errors.telefone}
                                            fullWidth
                                            id="telefone"
                                            name="telefone"
                                            label="Telefone"
                                            variant="outlined"
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                        </Grid>
                    </>
                );

            case 1:
                return (
                    <>
                        {/* Etapa 2: Endereço */}
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <InputMask
                                    mask="99999-999"
                                    value={toCep(dados.endereco.cep)} // Passa o valor formatado
                                    onChange={(e) => {
                                        const rawValue = e.target.value.replace(/\D/g, '');
                                        this.handleChange({ target: { name: 'endereco.cep', value: rawValue } });
                                    }}
                                    onBlur={async (e) => {
                                        const cepValue = e.target.value.replace(/\D/g, '');
                                        if (cepValue.length === 8) {
                                            try {
                                                const res = await fetch(`https://viacep.com.br/ws/${cepValue}/json/`);
                                                const data = await res.json();
                                                if (!data.erro) {
                                                    this.setState(prevState => ({
                                                        dados: {
                                                            ...prevState.dados,
                                                            endereco: {
                                                                ...prevState.dados.endereco,
                                                                logradouro: data.logradouro,
                                                                bairro: data.bairro,
                                                                cidade: data.localidade,
                                                                uf: data.uf,
                                                            }
                                                        }
                                                    }));
                                                } else {
                                                    alert('CEP não encontrado.');
                                                }
                                            } catch (error) {
                                                alert('Erro ao buscar CEP.');
                                                console.error('Erro ao buscar CEP:', error);
                                            }
                                        }
                                    }}
                                >
                                    {(inputProps) => (
                                        <TextField
                                            {...inputProps}
                                            InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                            error={!!errors['endereco.cep']}
                                            helperText={errors['endereco.cep']}
                                            fullWidth
                                            id="endereco.cep"
                                            name="endereco.cep"
                                            label="CEP"
                                            variant="outlined"
                                        />
                                    )}
                                </InputMask>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    error={!!errors['endereco.logradouro']}
                                    helperText={errors['endereco.logradouro']}
                                    fullWidth
                                    id="endereco.logradouro"
                                    name="endereco.logradouro"
                                    label="Logradouro"
                                    variant="outlined"
                                    value={dados.endereco.logradouro}
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    error={!!errors['endereco.numero']}
                                    helperText={errors['endereco.numero']}
                                    fullWidth
                                    id="endereco.numero"
                                    name="endereco.numero"
                                    label="Número"
                                    variant="outlined"
                                    value={dados.endereco.numero}
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    fullWidth
                                    id="endereco.complemento"
                                    name="endereco.complemento"
                                    label="Complemento (Opcional)"
                                    variant="outlined"
                                    value={dados.endereco.complemento}
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    error={!!errors['endereco.bairro']}
                                    helperText={errors['endereco.bairro']}
                                    fullWidth
                                    id="endereco.bairro"
                                    name="endereco.bairro"
                                    label="Bairro"
                                    variant="outlined"
                                    value={dados.endereco.bairro}
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    error={!!errors['endereco.cidade']}
                                    helperText={errors['endereco.cidade']}
                                    fullWidth
                                    id="endereco.cidade"
                                    name="endereco.cidade"
                                    label="Cidade"
                                    variant="outlined"
                                    value={dados.endereco.cidade}
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth variant="outlined" error={!!errors['endereco.uf']}>
                                    <InputLabel id="uf-select-label" style={{ fontWeight: 'bold' }}>Estado (UF)</InputLabel>
                                    <MuiSelect
                                        labelId="uf-select-label"
                                        id="endereco.uf"
                                        name="endereco.uf"
                                        value={dados.endereco.uf}
                                        onChange={this.handleChange}
                                        label="Estado (UF)"
                                    >
                                        <MenuItem value=""><em>Selecione</em></MenuItem>
                                        {([
                                            { nome: 'Acre', sigla: 'AC' }, { nome: 'Alagoas', sigla: 'AL' }, { nome: 'Amapá', sigla: 'AP' },
                                            { nome: 'Amazonas', sigla: 'AM' }, { nome: 'Bahia', sigla: 'BA' }, { nome: 'Ceará', sigla: 'CE' },
                                            { nome: 'Distrito Federal', sigla: 'DF' }, { nome: 'Espírito Santo', sigla: 'ES' }, { nome: 'Goiás', sigla: 'GO' },
                                            { nome: 'Maranhão', sigla: 'MA' }, { nome: 'Mato Grosso', sigla: 'MT' }, { nome: 'Mato Grosso do Sul', sigla: 'MS' },
                                            { nome: 'Minas Gerais', sigla: 'MG' }, { nome: 'Pará', sigla: 'PA' }, { nome: 'Paraíba', sigla: 'PB' },
                                            { nome: 'Paraná', sigla: 'PR' }, { nome: 'Pernambuco', sigla: 'PE' }, { nome: 'Piauí', sigla: 'PI' },
                                            { nome: 'Rio de Janeiro', sigla: 'RJ' }, { nome: 'Rio Grande do Norte', sigla: 'RN' }, { nome: 'Rio Grande do Sul', sigla: 'RS' },
                                            { nome: 'Rondônia', sigla: 'RO' }, { nome: 'Roraima', sigla: 'RR' }, { nome: 'Santa Catarina', sigla: 'SC' },
                                            { nome: 'São Paulo', sigla: 'SP' }, { nome: 'Sergipe', sigla: 'SE' }, { nome: 'Tocantins', sigla: 'TO' },
                                        ] ?? []).map((item) => (
                                            <MenuItem key={`uf-${item?.sigla}`} value={item?.sigla}>
                                                {item?.sigla} - {item?.nome}
                                            </MenuItem>
                                        ))}
                                    </MuiSelect>
                                    {errors['endereco.uf'] && <Typography className={classes.errorText}>{errors['endereco.uf']}</Typography>}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </>
                );

            case 2:
                return (
                    <>
                        {/* Etapa 3: Dados Profissionais */}
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    error={!!errors.sobre}
                                    helperText={errors.sobre}
                                    fullWidth
                                    id="sobre"
                                    name="sobre"
                                    label="Sobre (Currículo)"
                                    variant="outlined"
                                    multiline
                                    rows={4}
                                    value={dados.sobre}
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    id="especialidadeNome"
                                    options={especialidades.map((option) => option.nome)}
                                    getOptionLabel={(option) => option}
                                    value={dados.especialidadeNome}
                                    onChange={(event, newValue) => {
                                        this.setState(prevState => ({
                                            dados: {
                                                ...prevState.dados,
                                                especialidadeNome: newValue || '',
                                                especialidadeId: especialidades.find(esp => esp.nome === newValue)?.id || ''
                                            }
                                        }));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                            error={!!errors.especialidadeNome}
                                            helperText={errors.especialidadeNome}
                                            label="Especialidade"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" error={!!errors.conselhoProfissionalId}>
                                    <InputLabel id="conselho-select-label" style={{ fontWeight: 'bold' }}>Conselho Profissional</InputLabel>
                                    <MuiSelect
                                        labelId="conselho-select-label"
                                        id="conselhoProfissionalId"
                                        name="conselhoProfissionalId"
                                        value={dados.conselhoProfissionalId}
                                        onChange={this.handleChange}
                                        label="Conselho Profissional"
                                    >
                                        <MenuItem value=""><em>Selecione</em></MenuItem>

                                        {this.state.conselhos.map((conselho) => (
                                            <MenuItem key={`conselhoProfissionalId-${conselho.valor}`} value={conselho.valor}>
                                                {conselho.nome}
                                            </MenuItem>
                                        ))}
                                    </MuiSelect>
                                    {errors.conselhoProfissionalId && <Typography className={classes.errorText}>{errors.conselhoProfissionalId}</Typography>}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    error={!!errors.conselhoProfissionalUf}
                                    helperText={errors.conselhoProfissionalUf}
                                    fullWidth
                                    id="conselhoProfissionalUf"
                                    name="conselhoProfissionalUf"
                                    label="UF do Conselho"
                                    variant="outlined"
                                    value={dados.conselhoProfissionalUf}
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                    error={!!errors.conselhoProfissionalNumero}
                                    helperText={errors.conselhoProfissionalNumero}
                                    fullWidth
                                    id="conselhoProfissionalNumero"
                                    name="conselhoProfissionalNumero"
                                    label="Número do Conselho"
                                    variant="outlined"
                                    value={dados.conselhoProfissionalNumero}
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" error={!!errors.idiomasId}>
                                    <InputLabel id="idiomas-select-label" style={{ fontWeight: 'bold' }}>Idiomas de Atendimento</InputLabel>
                                    <MuiSelect
                                        labelId="idiomas-select-label"
                                        multiple
                                        value={this.state?.dados?.idiomasId ?? []}
                                        onChange={(e) => this.handleChange({ target: { name: 'idiomasId', value: e.target.value } })}
                                        renderValue={(selected) => selected.map(id => idiomas.find(idioma => idioma.id === id)?.label).join(', ')}
                                        label="Idiomas de Atendimento"
                                    >
                                        {idiomas.map(idioma => (
                                            <MenuItem key={idioma.id} value={idioma.id}>
                                                <Checkbox checked={dados.idiomasId.indexOf(idioma.id) > -1} />
                                                <ListItemText primary={idioma.label} />
                                            </MenuItem>
                                        ))}
                                    </MuiSelect>
                                    {errors.idiomasId && <Typography className={classes.errorText}>{errors.idiomasId}</Typography>}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" error={!!errors.gruposAtendimento}>
                                    <InputLabel id="grupos-select-label" style={{ fontWeight: 'bold' }}>Grupos Atendidos</InputLabel>
                                    <MuiSelect
                                        labelId="grupos-select-label"
                                        multiple
                                        value={this.state?.dados?.grupoAtendimentoId ?? []}
                                        onChange={(e) => this.handleChange({ target: { name: 'grupoAtendimentoId', value: e.target.value } })}
                                        renderValue={(selected) => selected.map(id => gruposAtendimento.find(grupo => grupo.id === id)?.nome).join(', ')}
                                        label="Grupos Atendidos"
                                    >
                                        {gruposAtendimento.map(grupo => (
                                            <MenuItem key={grupo.id} value={grupo.id}>
                                                <Checkbox checked={dados.grupoAtendimentoId.indexOf(grupo.id) > -1} />
                                                <ListItemText primary={grupo.nome} />
                                            </MenuItem>
                                        ))}
                                    </MuiSelect>
                                    {errors.grupoAtendimentoId && <Typography className={classes.errorText}>{errors.grupoAtendimentoId}</Typography>}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </>
                );

            case 3:
                return (
                    <>
                        {/* Etapa 4: Formação Acadêmica */}
                        <Grid container spacing={3}>
                            {dados.formacaoAcademica.map((formacao, index) => (
                                <Grid item xs={12} key={index}>
                                    <Card style={{ marginBottom: '20px', border: '1px solid #ccc', padding: '15px' }}>
                                        <Typography variant="h6" style={{ marginBottom: '10px' }}>Formação Acadêmica {index + 1}</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                                    fullWidth
                                                    id={`formacaoAcademica.${index}.tipo`}
                                                    name={`formacaoAcademica.${index}.tipo`}
                                                    label="Tipo de Formação"
                                                    variant="outlined"
                                                    value={formacao.tipo}
                                                    onChange={(e) => this.handleArrayChange(index, 'tipo', e.target.value, 'formacaoAcademica')}
                                                    error={!!errors[`formacaoAcademica.${index}.tipo`]}
                                                    helperText={errors[`formacaoAcademica.${index}.tipo`]}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                                    fullWidth
                                                    id={`formacaoAcademica.${index}.instituicao`}
                                                    name={`formacaoAcademica.${index}.instituicao`}
                                                    label="Instituição"
                                                    variant="outlined"
                                                    value={formacao.instituicao}
                                                    onChange={(e) => this.handleArrayChange(index, 'instituicao', e.target.value, 'formacaoAcademica')}
                                                    error={!!errors[`formacaoAcademica.${index}.instituicao`]}
                                                    helperText={errors[`formacaoAcademica.${index}.instituicao`]}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                                    fullWidth
                                                    id={`formacaoAcademica.${index}.formacao`}
                                                    name={`formacaoAcademica.${index}.formacao`}
                                                    label="Formação/Curso"
                                                    variant="outlined"
                                                    value={formacao.formacao}
                                                    onChange={(e) => this.handleArrayChange(index, 'formacao', e.target.value, 'formacaoAcademica')}
                                                    error={!!errors[`formacaoAcademica.${index}.formacao`]}
                                                    helperText={errors[`formacaoAcademica.${index}.formacao`]}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    InputLabelProps={{ style: { fontWeight: 'bold' }, shrink: true }}
                                                    fullWidth
                                                    id={`formacaoAcademica.${index}.dataDe`}
                                                    name={`formacaoAcademica.${index}.dataDe`}
                                                    label="Data de Início"
                                                    type="date"
                                                    variant="outlined"
                                                    value={formacao.dataDe}
                                                    onChange={(e) => this.handleArrayChange(index, 'dataDe', e.target.value, 'formacaoAcademica')}
                                                    error={!!errors[`formacaoAcademica.${index}.dataDe`]}
                                                    helperText={errors[`formacaoAcademica.${index}.dataDe`]}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    InputLabelProps={{ style: { fontWeight: 'bold' }, shrink: true }}
                                                    fullWidth
                                                    id={`formacaoAcademica.${index}.dataAte`}
                                                    name={`formacaoAcademica.${index}.dataAte`}
                                                    label="Data de Conclusão"
                                                    type="date"
                                                    variant="outlined"
                                                    value={formacao.dataAte}
                                                    onChange={(e) => this.handleArrayChange(index, 'dataAte', e.target.value, 'formacaoAcademica')}
                                                />
                                            </Grid>

                                            {dados.formacaoAcademica.length > 1 && (
                                                <Grid item xs={12}>
                                                    <Button
                                                        onClick={() => this.removeArrayItem(index, 'formacaoAcademica')}
                                                        variant="outlined"
                                                        color="secondary"
                                                        startIcon={<DeleteForever />}
                                                    >
                                                        Remover Formação
                                                    </Button>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Card>
                                </Grid>
                            ))}
                            <Grid item xs={12}>
                                <Button
                                    onClick={() => this.addArrayItem('formacaoAcademica', { tipo: '', instituicao: '', formacao: '', dataDe: '', dataAte: '' })}
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Add />}
                                >
                                    Adicionar Mais Formação
                                </Button>
                                {errors.formacaoAcademica && <Typography className={classes.errorText}>{errors.formacaoAcademica}</Typography>}
                            </Grid>
                        </Grid>
                    </>
                );

            case 4:
                return (
                    <>
                        {/* Etapa 5: Finalizar (reCAPTCHA e Termos) */}
                        <Grid container spacing={3}>
                            <Box display="flex" flexDirection="column" gap={3}>
                                <Card>
                                    <CardHeader title="Resumo do Cadastro" />
                                    <CardContent>
                                        <Grid container spacing={2}>
                                            {this.state?.dados?.formacaoAcademica?.map((f, i) => (
                                                <React.Fragment key={i}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="subtitle2">Dados Pessoais</Typography>
                                                        <Typography variant="subtitle2">Nome: {dados.nome}</Typography>
                                                        <Typography variant="subtitle2">Sexo: {dados.sexo}</Typography>
                                                        <Typography variant="subtitle2">CPF/CNPJ: {dados.documentoNumero}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="subtitle2">Dados de Contato</Typography>
                                                        <Typography variant="subtitle2">Email: {dados.email}</Typography>
                                                        <Typography variant="subtitle2">Telefone: {dados.telefone}</Typography>
                                                        <Typography variant="subtitle2">Endereço: {dados.endereco.logradouro}, {dados.endereco.numero} - {dados.endereco.bairro}, {dados.endereco.cidade}/{dados.endereco.uf}, CEP {dados.endereco.cep}</Typography>


                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="subtitle2">Dados Profissionais</Typography>
                                                        <Typography variant="subtitle2">Data de Início: {dados.dataIniProf}</Typography>
                                                        <Typography variant="subtitle2">Currículo: {dados.sobre}</Typography>
                                                        <Typography variant="subtitle2">Especialidade: {this.state.dados.especialidadeNome ?? ' - '}</Typography>
                                                        <Typography variant="subtitle2">Conselho: {this.state.conselhos.find(con => con.valor == dados.conselhoProfissionalId)?.nome ?? ' - '}</Typography>
                                                        <Typography variant="subtitle2">Nº Conselho: {`${dados.conselhoProfissionalNumero} - ${dados.conselhoProfissionalUf}`}</Typography>
                                                        <Typography variant="subtitle2">Grupo: {this.state.gruposAtendimento.filter(gra => dados.grupoAtendimentoId.includes(gra.id)).map(gra => gra.nome).join(', ')}</Typography>
                                                        <Typography variant="subtitle2">Idioma: {this.state.idiomas?.filter(idioma => dados.idiomasId.includes(idioma.id)).map(idioma => idioma.label).join(', ')}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="subtitle2">Período: </Typography>
                                                        <Typography>{moment(f.dataDe).format('DD/MM/YYYY')} até {moment(f.dataAte).format('DD/MM/YYYY')}</Typography>
                                                    </Grid>
                                                </React.Fragment>
                                            ))}
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Card>
                                    <CardHeader title="Formações Acadêmicas" />
                                    <CardContent>
                                        <Grid container spacing={2}>
                                            {this.state?.dados?.formacaoAcademica?.map((f, i) => (
                                                <React.Fragment key={i}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="subtitle2">Tipo</Typography>
                                                        <Typography>{f.tipo}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="subtitle2">Nome:</Typography>
                                                        <Typography>{f.formacao}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="subtitle2">Instituição:</Typography>
                                                        <Typography>{f.instituicao}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="subtitle2">Período:</Typography>
                                                        <Typography>{moment(f.dataDe).format('DD/MM/YYYY')} até {moment(f.dataAte).format('DD/MM/YYYY')}</Typography>
                                                    </Grid>
                                                </React.Fragment>
                                            ))}
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Box>



                            <Grid item xs={12}>
                                <ReCAPTCHA
                                    sitekey={BRANDING?.recaptcha?.secret_key || "YOUR_RECAPTCHA_SITE_KEY"}
                                    onChange={(value) => this.setState({ captcha: value })}
                                />
                                {errors.captcha && <Typography className={classes.errorText}>{errors.captcha}</Typography>}
                            </Grid>

                            <Grid item xs={12}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        checked={dados.termos}
                                        onChange={this.handleChange}
                                        name="termos"
                                        color="primary"
                                    />
                                    <Typography variant="body2" component="label" htmlFor="termos">
                                        Eu concordo com os <a href="https://simdoctor.com.br/termos-e-condicoes">Termos de Serviço</a> e a <a href="https://simdoctor.com.br/politica-de-privacidade">Política de Privacidade</a>.
                                    </Typography>
                                </div>
                                {errors.termos && <Typography className={classes.errorText}>{errors.termos}</Typography>}
                            </Grid>
                        </Grid>
                    </>
                );

            default:
                return null;
        }
    };

    render() {
        const { classes } = this.props; // Acessa os estilos via props
        const { loading, errors, captcha, activeStep, dados, cadastrado, enviaDepCodConfirmacao } = this.state;

        // Telas de sucesso/confirmação (mantidas do seu código original)
        if (cadastrado === true) {
            return (
                <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center' }}>
                    <div>
                        <div style={{ marginTop: 30, backgroundColor: 'white', maxWidth: 950, padding: 10, borderRadius: 10 }}>
                            <div style={{ height: 170, overflowY: 'auto' }}> {/* Substituído ScrollView por div com overflow */}
                                <div>
                                    <Box mt={3} pb={3} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                                        <CheckCircleOutlineRounded color="secondary" style={{ fontSize: 100 }} />
                                        <Typography variant="subtitle1" style={{ marginBottom: 5, marginTop: 10 }}>
                                            Seu cadastro foi enviado para aprovação com sucesso!
                                        </Typography>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (enviaDepCodConfirmacao === false) {
            return (
                <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center' }}>
                    <div>
                        <div style={{ marginTop: 30, backgroundColor: 'white', maxWidth: 950, padding: 10, borderRadius: 10 }}>
                            <div style={{ height: 170, overflowY: 'auto' }}>
                                <div>
                                    <Box mt={1} pb={3} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                                        <Typography variant="subtitle1" style={{ marginBottom: 15 }}>Insira o código de confirmação</Typography>
                                        <TextField
                                            size="small"
                                            style={{ width: window.innerWidth >= 680 ? 180 : "100%" }}
                                            label="Código"
                                            variant="outlined"
                                            value={this.state.codigoConfirmacao}
                                            onChange={(e) => this.setState({ codigoConfirmacao: e.target.value })}
                                        />
                                    </Box>
                                </div>
                            </div>
                        </div>
                        <Box mt={2} display="flex" flexDirection="row" justifyContent="center">
                            <Button disabled={loading} variant={"contained"} color={"primary"} onClick={this.registerHandler}>
                                Enviar
                            </Button>
                        </Box>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <Box mb={3} mt={4}>
                    <img
                        src={BRANDING?.loginLogo?.img}
                        style={{ display: "flex", margin: "auto", marginBottom: 15 }}
                        height={BRANDING?.loginLogo?.height}
                        alt="Logo da Marca"
                    />
                </Box>

                <Card className={classes.root}>
                    <CardContent>
                        {/* BREADCRUMB / STEPPER */}
                        <Typography variant="h6" className={classes.stepHeader}>
                            Cadastro de Profissional
                        </Typography>
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {this.steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel onClick={() => {
                                        // Permite clicar em etapas anteriores para revisão
                                        if (activeStep > index) {
                                            this.setState({ activeStep: index, errors: {} });
                                        }
                                    }}>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <Typography variant="body2" style={{ marginTop: 8 }}>
                            Etapa {activeStep + 1} de {this.steps.length} — {this.steps[activeStep]}
                        </Typography>

                        <Box mt={3}>
                            <this.StepContent stepIndex={activeStep} />
                        </Box>
                    </CardContent>

                    {/* Rodapé com navegação */}
                    <CardActions style={{ padding: 16 }}>
                        <div className={classes.stepFooter} style={{ width: '100%' }}>
                            <Button onClick={this.handleBack} disabled={activeStep === 0}>
                                Voltar
                            </Button>

                            {activeStep < this.steps.length - 1 ? (
                                <Button variant="contained" color="primary" onClick={this.handleNext}>
                                    Próximo
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.registerHandler}
                                    disabled={loading || !dados.termos}
                                >
                                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Cadastrar'}
                                </Button>
                            )}
                        </div>
                    </CardActions>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (store) => ({
    aDialog: store.authReducer.authDialog,
    data: store.authReducer.data,
    loading: store.appReducer.loading,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { setProfileDialog, setLoading, authDialog, setAuth, JWT_Decode, api: GetHandler },
        dispatch
    );

export default withRouter(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Register)));